module.exports = __webpack_public_path__ + "static/media/map.2d45716b.png";